import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ConciliationModel } from "../../../conciliation/models/ConciliationModel"; 
import { getAllReportConciliations } from "../../../../service/conciliation/Conciliation";

export const useGetReportConciliations = (id_dia: number, idTipo: number) => {
  const [conciliationsList, setConciliationsList] = useState<
    ConciliationModel[]
  >([]);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(true);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      const res = await getAllReportConciliations(id_dia, idTipo)
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setConciliationsList(res.rows);
        setLoadingRequest(false);
      }
    };
    if (id_dia) {
      fetchPost();

    }else{
      setLoadingRequest(false);
    }
  }, [id_dia, idTipo]);

  return { conciliationsList, loadingRequest };
};
